export default __webpack_public_path__ + "static/media/2024.7f2b0a43.pdf";